(function () {
  'use strict';

  // ── BalmyProductDrum ──────────────────────────────────────────────
  // ── Bundle box yardimcilari ───────────────────────────────────────
  // Liquid tarafinda kayitlar '~||~', alanlar '~|~' ile ayrilir; her alanin
  // sonundaki '§' sentinel bos alanlarin kaybolmasini engeller.
  const BB_R = '~||~';
  const BB_D = '~|~';
  const bbStrip = s => String(s || '').replace(/§$/, '');
  function bbText(el, val) {
    if (!el) return;
    el.textContent = val || '';
    el.hidden = !val;
  }
  // Anahtar metinlerindeki yer tutucular:
  //   [price] fark, [value] eklenen urunlerin degeri, [save] deger - fark
  function bbTokens(tpl, d) {
    return String(tpl || '')
      .replace('[price]', d.ud || '')
      .replace('[value]', d.ad || '')
      .replace('[save]',  d.as || '');
  }
  function bbCell(cell, val) {
    if (!cell) return;
    const v = cell.querySelector('.bpd__bundle-cell-value');
    if (v) {
      const s = v.querySelector('s');
      (s || v).textContent = val || '';
    }
    cell.hidden = !val;
  }

  class BalmyProductDrum {
    constructor(root) {
      this.root = root;
      this.sid  = root.dataset.sid;

      // Parse Liquid-injected JSON
      this.imgs     = JSON.parse(document.getElementById('bpd-imgs-'      + this.sid).textContent);
      this.variants = JSON.parse(document.getElementById('bpd-variants-'  + this.sid).textContent);
      this.blocks   = JSON.parse(document.getElementById('bpd-blocks-'    + this.sid).textContent);
      const swatchesEl = document.getElementById('bpd-swatches-' + this.sid);
      this.swatches = swatchesEl ? JSON.parse(swatchesEl.textContent) : [];

      // DOM refs — gallery
      this.mainImg  = root.querySelector('.bpd__gal-main-img');
      this.thumbsEl = root.querySelector('.bpd__gal-thumbs');
      this.prevBtn  = root.querySelector('.bpd__gal-prev');
      this.nextBtn  = root.querySelector('.bpd__gal-next');

      // DOM refs — info
      this.priceNow    = root.querySelector('.bpd__price-now');
      this.priceCmp    = root.querySelector('.bpd__price-compare');
      this.atcBtn      = root.querySelector('.bpd__atc-btn');
      this.opt1Desc    = root.querySelector('.bpd__opt1-desc');
      this.opt1Badge   = root.querySelector('.bpd__opt1-badge');
      this.opt1Selected = root.querySelector('.bpd__opt1-selected');
      this.opt2Selected = root.querySelector('.bpd__opt2-selected');
      this.audioEl     = root.querySelector('.bpd__audio');
      this.audioBtn    = root.querySelector('.bpd__audio-btn');

      // State
      const fv = this.variants[0] || {};
      this.currentOpt1   = fv.opt1 || '';
      this.currentOpt2   = fv.opt2 || '';
      this.currentIdx    = 0;
      this.filteredImgs  = [];

      this.currentVariantId = fv.id || null;
      this.mainVideo = null;
      this.mainEmbed = null;

      this._buildMaps();
      this._buildSwatchMap();
      this._bindEvents();
      this._buildSheet();
      this._setupSticky();
      this.update(this.currentOpt1, this.currentOpt2);
    }

    // ── Swatch image override map ───────────────────────────────────
    // Keys: "opt1_lc|opt2_lc" (specific) AND "|opt2_lc" (global fallback — first img per opt2)
    _buildSwatchMap() {
      this.swatchMap = {};
      const opt2First = {};
      this.swatches.forEach(s => {
        const opt1lc = (s.opt1 || '').toLowerCase();
        const opt2lc = (s.opt2 || '').toLowerCase();
        if (s.img) {
          this.swatchMap[opt1lc + '|' + opt2lc] = s.img;
          if (!opt2First[opt2lc]) opt2First[opt2lc] = s.img;
        }
      });
      // Populate global ("|opt2_lc") keys so swatches work on any opt1 switch
      Object.keys(opt2First).forEach(opt2lc => {
        this.swatchMap['|' + opt2lc] = opt2First[opt2lc];
      });
    }

    // ── Pre-build O(1) lookup maps ──────────────────────────────────
    _buildMaps() {
      // variantMap: "opt1_lc|opt2_lc" → variant object
      this.variantMap = {};
      this.opt1Values  = [];
      this.opt2Values  = [];

      this.variants.forEach(v => {
        const k = (v.opt1 || '').toLowerCase() + '|' + (v.opt2 || '').toLowerCase();
        this.variantMap[k] = v;
        if (!this.opt1Values.includes(v.opt1)) this.opt1Values.push(v.opt1);
        if (!this.opt2Values.includes(v.opt2)) this.opt2Values.push(v.opt2);
      });

      // imgMap: "opt1_lc|opt2_lc" → [indices] (also "opt1_lc|" and "|" for orphans)
      this.imgMap = {};
      this.imgs.forEach((img, i) => {
        const k1  = (img.opt1 || '').toLowerCase();
        const k2  = (img.opt2 || '').toLowerCase();
        const key = k1 + '|' + k2;
        if (!this.imgMap[key]) this.imgMap[key] = [];
        this.imgMap[key].push(i);
      });
    }

    // ── Return media for exact opt1+opt2 match ─────────────────────
    // Each media's opt1/opt2 was resolved server-side: images AND videos
    // inherit the last-seen variant-attached image's options, so a video
    // belongs to whichever variant block it sits in (admin media order).
    // Media before the first variant-attached image lives under the blank
    // "|" key and is shown for every variant.
    _getVisible(opt1, opt2) {
      const k         = opt1.toLowerCase() + '|' + opt2.toLowerCase();
      const varIdx    = this.imgMap[k] || [];
      if (varIdx.length === 0) return this.imgs;
      const sharedIdx = this.imgMap['|'] || [];
      const merged    = [...new Set([...varIdx, ...sharedIdx])].sort((a, b) => a - b);
      return merged.map(i => this.imgs[i]);
    }

    // ── Responsive srcset from a Shopify CDN URL ────────────────────
    _makeSrcset(src) {
      return [375, 600, 900, 1200].map(w =>
        src.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w'
      ).join(', ');
    }

    // ── Preload images so thumbnail clicks feel instant ─────────────
    _preload(imgList) {
      imgList.forEach(item => {
        if (!item.type || item.type === 'image') {
          const el = new Image();
          el.src = item.src;
        }
      });
    }

    // ── Master update ───────────────────────────────────────────────
    update(opt1, opt2) {
      this.currentOpt1 = opt1;
      this.currentOpt2 = opt2;
      this.currentIdx  = 0;

      this._updateGallery();
      this._updateActiveStates();
      this._updatePrice();
      this._updateBundle();
      this._updateCardPrices();
      this._updateColorImages();
      this._updateOpt1Content();
    }

    // ── Bundle box ───────────────────────────────────────────────────
    // Paket kutusunun verisi varyant metafield'lerinde durur (upsell slot 1-4).
    // Renk/varyant degisince kutudaki gorsel, isim, fiyat ve toplamlar da degisir.
    // Markup sunucuda basilir; burada sadece mevcut dugumlerin icerigi guncellenir.
    _initBundles() {
      this.bundles = [];
      this.root.querySelectorAll('.bpd__bundle[data-bundle-dynamic]').forEach(el => {
        const dataEl = el.querySelector('.bpd__bundle-data');
        if (!dataEl) return;
        let map;
        try {
          map = JSON.parse(dataEl.textContent);
        } catch (e) {
          return;
        }
        const upgrade = el.querySelector('.bpd__bundle-upgrade');
        const input   = el.querySelector('.bpd__bundle-upgrade-input');

        this.bundles.push({
          el,
          map,
          items:     Array.from(el.querySelectorAll('.bpd__bundle-item')),
          plus:      Array.from(el.querySelectorAll('.bpd__bundle-plus')),
          foot:      el.querySelector('.bpd__bundle-foot'),
          totals:    el.querySelector('.bpd__bundle-totals'),
          cellTotal: el.querySelector('.bpd__bundle-cell--total'),
          cellSave:  el.querySelector('.bpd__bundle-cell--save'),
          cellFinal: el.querySelector('.bpd__bundle-cell--final'),
          upgrade,
          upgradeInput: input,
          upgradeText:  el.querySelector('.bpd__bundle-upgrade-text'),
          upgradeSub:   el.querySelector('.bpd__bundle-upgrade-sub'),
          upgradePrice: el.querySelector('.bpd__bundle-upgrade-price'),
          upgradeTpl:    upgrade ? upgrade.dataset.upgradeTpl || '' : '',
          upgradeSubTpl: upgrade ? upgrade.dataset.upgradeSubTpl || '' : '',
          upgradeId:    null
        });

        if (input) input.addEventListener('change', () => this._applyBundleUpgrade());
      });
    }

    _updateBundle() {
      if (!this.bundles) this._initBundles();
      if (!this.bundles.length) return;

      const id = this.currentVariantId;

      this.bundles.forEach(b => {
        const d = b.map[id];
        if (!d) { b.el.hidden = true; return; }
        // Bu varyantta hic slot tanimli degilse kutuyu tamamen gizle
        b.el.hidden = !(d.n > 0);
        if (!(d.n > 0)) return;

        const recs = String(d.r || '').split(BB_R).filter(Boolean);

        b.items.forEach((item, i) => {
          const sep = i > 0 ? b.plus[i - 1] : null;
          const rec = recs[i];

          if (!rec) {
            item.hidden = true;
            if (sep) sep.hidden = true;
            return;
          }
          item.hidden = false;
          if (sep) sep.hidden = false;

          const f       = rec.split(BB_D).map(bbStrip);
          const name    = f[0], sub = f[1], img240 = f[2], img120 = f[3], price = f[4], was = f[5];

          const imgEl = item.querySelector('img');
          if (imgEl) {
            if (img240) {
              imgEl.src    = img240;
              imgEl.srcset = img120 ? img120 + ' 120w, ' + img240 + ' 240w' : '';
              imgEl.alt    = name || '';
              imgEl.hidden = false;
            } else {
              imgEl.hidden = true;
            }
          }

          bbText(item.querySelector('.bpd__bundle-name'), name);
          bbText(item.querySelector('.bpd__bundle-sub'),  sub);
          bbText(item.querySelector('.bpd__bundle-now'),  price);
          bbText(item.querySelector('.bpd__bundle-was'),  was);

          const priceWrap = item.querySelector('.bpd__bundle-price');
          if (priceWrap) priceWrap.hidden = !price && !was;
        });

        bbCell(b.cellTotal, d.t);
        bbCell(b.cellSave,  d.s);
        bbCell(b.cellFinal, d.b);
        if (b.totals) b.totals.hidden = !(d.t || d.s || d.b);
        // Sadece paket fiyati kaliyorsa masaustunde yan yana dizilim
        if (b.foot) b.foot.classList.toggle('bpd__bundle-foot--split', !d.t && !d.s);

        // Yukseltme anahtari: hedef varyant ve fiyat farki varyanta gore degisir
        if (b.upgrade) {
          if (d.u && d.ud) {
            b.upgrade.hidden = false;
            b.upgradeId = d.u;
            if (b.upgradeText) b.upgradeText.textContent = bbTokens(b.upgradeTpl, d);
            if (b.upgradeSub) {
              const sub = bbTokens(b.upgradeSubTpl, d);
              b.upgradeSub.textContent = sub;
              b.upgradeSub.hidden = !b.upgradeSubTpl || !sub;
            }
            // Rozet yalnizca metinde [price] gecmiyorsa gosterilir — rakam iki kez cikmasin
            if (b.upgradePrice) {
              const badge = String(b.upgradeTpl || '').indexOf('[price]') === -1;
              b.upgradePrice.textContent = '+' + d.ud;
              b.upgradePrice.hidden = !badge;
            }
          } else {
            b.upgrade.hidden = true;
            b.upgradeId = null;
            if (b.upgradeInput) b.upgradeInput.checked = false;
          }
        }
      });

      this._applyBundleUpgrade();
    }

    // Anahtar acikken Sepete Ekle hedefini upgrade varyantina cevir.
    // Upsell modali "secili varyantin upgrade'i var mi" diye baktigi icin,
    // dataset upgrade varyantini gosterdiginde modal kendiliginden susar.
    _applyBundleUpgrade() {
      let id = null;
      (this.bundles || []).forEach(b => {
        if (b.upgradeInput && b.upgradeInput.checked && b.upgradeId) id = b.upgradeId;
      });
      this.bundleUpgradeId = id;
      if (this.atcBtn) this.atcBtn.dataset.variantId = id || this.currentVariantId;
    }

    // ── Gallery ─────────────────────────────────────────────────────
    _updateGallery() {
      this.filteredImgs = this._getVisible(this.currentOpt1, this.currentOpt2);
      if (this.filteredImgs.length > 0) {
        this._showMedia(this.filteredImgs[0]);
        const first = this.filteredImgs[0];
        const sheetSrc = first.poster || first.src;
        if (this.sheetHdrImg) this.sheetHdrImg.src = sheetSrc;
        if (this.sheetGalImg) this.sheetGalImg.src = sheetSrc;
      }
      // Preload all images for this variant so clicks are instant
      this._preload(this.filteredImgs);
      this._renderThumbs();
      this._updateArrows();
    }

    _renderThumbs() {
      if (!this.thumbsEl) return;
      this.thumbsEl.innerHTML = '';
      this.filteredImgs.forEach((item, i) => {
        const wrap = document.createElement('div');
        wrap.className = 'bpd__gal-thumb' + (i === 0 ? ' active' : '');
        const imgEl = document.createElement('img');
        imgEl.src     = item.thumb;
        imgEl.alt     = item.alt || '';
        imgEl.loading = 'lazy';
        wrap.appendChild(imgEl);
        if (item.type === 'video' || item.type === 'external_video') {
          const play = document.createElement('div');
          play.style.cssText = 'position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.25);pointer-events:none;border-radius:inherit;';
          play.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="white" aria-hidden="true"><polygon points="5,3 19,12 5,21"/></svg>';
          wrap.style.position = 'relative';
          wrap.appendChild(play);
        }
        wrap.addEventListener('click', () => this._goTo(i));
        this.thumbsEl.appendChild(wrap);
      });
    }

    _goTo(idx) {
      if (!this.filteredImgs.length) return;
      this.currentIdx = ((idx % this.filteredImgs.length) + this.filteredImgs.length) % this.filteredImgs.length;
      this._showMedia(this.filteredImgs[this.currentIdx]);
      if (this.thumbsEl) {
        this.thumbsEl.querySelectorAll('.bpd__gal-thumb').forEach((t, i) => t.classList.toggle('active', i === this.currentIdx));
        const active = this.thumbsEl.children[this.currentIdx];
        if (active) active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
      this._updateArrows();
    }

    _updateArrows() {
      const show = this.filteredImgs.length > 1;
      if (this.prevBtn) this.prevBtn.style.display = show ? '' : 'none';
      if (this.nextBtn) this.nextBtn.style.display = show ? '' : 'none';
    }

    _showMedia(item) {
      const type    = item.type || 'image';
      const mainDiv = this.mainImg ? this.mainImg.parentElement : null;
      if (!mainDiv) return;

      if (this.mainVideo && type !== 'video') {
        this.mainVideo.pause();
        this.mainVideo.style.display = 'none';
      }
      if (this.mainEmbed && type !== 'external_video') {
        this.mainEmbed.src = '';
        this.mainEmbed.style.display = 'none';
      }

      if (type === 'video') {
        this.mainImg.style.display = 'none';
        if (!this.mainVideo) {
          this.mainVideo = document.createElement('video');
          this.mainVideo.className = 'bpd__gal-main-video';
          this.mainVideo.setAttribute('playsinline', '');
          this.mainVideo.setAttribute('controls', '');
          this.mainVideo.style.cssText = 'width:100%;height:100%;object-fit:contain;display:block;border-radius:inherit;';
          mainDiv.appendChild(this.mainVideo);
        }
        this.mainVideo.poster = item.poster || '';
        this.mainVideo.src    = item.src || '';
        this.mainVideo.style.display = 'block';
        this.mainVideo.load();

      } else if (type === 'external_video') {
        this.mainImg.style.display = 'none';
        if (!this.mainEmbed) {
          this.mainEmbed = document.createElement('iframe');
          this.mainEmbed.className = 'bpd__gal-main-embed';
          this.mainEmbed.setAttribute('allowfullscreen', '');
          this.mainEmbed.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
          this.mainEmbed.style.cssText = 'width:100%;height:auto;border:0;display:block;position:relative;top:50%;transform:translateY(-50%);';
          mainDiv.appendChild(this.mainEmbed);
        }
        this.mainEmbed.style.aspectRatio = String(item.ratio || 1.7778);
        let url = '';
        if (item.host === 'youtube')
          url = 'https://www.youtube.com/embed/' + item.external_id + '?autoplay=1&rel=0';
        else if (item.host === 'vimeo')
          url = 'https://player.vimeo.com/video/' + item.external_id + '?autoplay=1';
        this.mainEmbed.src = url;
        this.mainEmbed.style.display = 'block';

      } else {
        this.mainImg.style.display = '';
        this.mainImg.srcset = '';
        this.mainImg.src    = item.src || '';
        this.mainImg.alt    = item.alt || '';
      }
    }

    // ── Active states on selectors ──────────────────────────────────
    _updateActiveStates() {
      [this.root, this.sheetBody].filter(Boolean).forEach(container => {
        container.querySelectorAll('[data-opt1]').forEach(btn => {
          btn.classList.toggle('active', btn.dataset.opt1 === this.currentOpt1);
        });
        container.querySelectorAll('[data-opt2]').forEach(btn => {
          const isActive = btn.dataset.opt2 === this.currentOpt2;
          btn.classList.toggle('active', isActive);
          const k = this.currentOpt1.toLowerCase() + '|' + btn.dataset.opt2.toLowerCase();
          const v = this.variantMap[k];
          btn.classList.toggle('unavailable', !v || !v.available);
        });
        container.querySelectorAll('[data-opt2-name]').forEach(el => {
          el.classList.toggle('active', el.dataset.opt2Name === this.currentOpt2);
        });
        container.querySelectorAll('[data-opt1-name]').forEach(el => {
          el.classList.toggle('active', el.dataset.opt1Name === this.currentOpt1);
        });
      });
    }

    // ── Update prices inside each model card ────────────────────────
    // Called on every opt2 change so all cards reflect the new color's price
    _updateCardPrices() {
      [this.root, this.sheetBody].filter(Boolean).forEach(container => {
        container.querySelectorAll('[data-opt1]').forEach(card => {
          const k = card.dataset.opt1.toLowerCase() + '|' + this.currentOpt2.toLowerCase();
          const v = this.variantMap[k];
          if (!v) return;

          const priceEl    = card.querySelector('.bpd__card-price');
          const compareEl  = card.querySelector('.bpd__card-compare');
          const discountEl = card.querySelector('.bpd__card-discount-badge');

          if (priceEl) priceEl.textContent = v.pf;

          if (compareEl) {
            compareEl.textContent   = v.cf || '';
            compareEl.style.display = v.cf ? '' : 'none';
          }

          if (discountEl) {
            if (v.cp && v.cp > 0 && v.p < v.cp) {
              const pct = Math.round((1 - v.p / v.cp) * 100);
              discountEl.textContent   = pct + '% OFF';
              discountEl.style.display = '';
            } else {
              discountEl.style.display = 'none';
            }
          }

          const cardImg = card.querySelector('.bpd__card-color-img');
          if (cardImg) {
            const swKey    = card.dataset.opt1.toLowerCase() + '|' + this.currentOpt2.toLowerCase();
            const globalKey = '|' + this.currentOpt2.toLowerCase();
            const newSrc   = this.swatchMap[swKey] || this.swatchMap[globalKey] || (v && v.img);
            if (newSrc) cardImg.src = newSrc;
          }
        });

        // Update swatch-mode standalone price row (used when show_as_color_swatch is on)
        const swatchPriceRow = container.querySelector('.bpd__swatch-price-row');
        if (swatchPriceRow) {
          const k   = this.currentOpt1.toLowerCase() + '|' + this.currentOpt2.toLowerCase();
          const k1  = this.currentOpt1.toLowerCase() + '|';
          const sv  = this.variantMap[k] || this.variantMap[k1];
          if (sv) {
            const priceEl   = swatchPriceRow.querySelector('.bpd__card-price');
            const compareEl = swatchPriceRow.querySelector('.bpd__card-compare');
            const discEl    = swatchPriceRow.querySelector('.bpd__card-discount-badge');
            if (priceEl) priceEl.textContent = sv.pf;
            if (compareEl) { compareEl.textContent = sv.cf || ''; compareEl.style.display = sv.cf ? '' : 'none'; }
            if (discEl) {
              if (sv.cp && sv.cp > 0 && sv.p < sv.cp) {
                discEl.textContent = Math.round((1 - sv.p / sv.cp) * 100) + '% OFF';
                discEl.style.display = '';
              } else {
                discEl.style.display = 'none';
              }
            }
          }
        }
      });
    }

    // ── Price + ATC button ──────────────────────────────────────────
    _updatePrice() {
      const k = this.currentOpt1.toLowerCase() + '|' + this.currentOpt2.toLowerCase();
      const v = this.variantMap[k];
      if (!v) return;

      this.currentVariantId = v.id;

      if (this.priceNow) this.priceNow.textContent = v.pf;

      if (this.priceCmp) {
        if (v.cf) {
          this.priceCmp.textContent  = v.cf;
          this.priceCmp.style.display = '';
        } else {
          this.priceCmp.style.display = 'none';
        }
      }

      if (this.atcBtn) {
        this.atcBtn.disabled          = !v.available;
        this.atcBtn.textContent       = v.available ? (this.atcBtn.dataset.atc || 'Add to Cart') : (this.atcBtn.dataset.soldout || 'Sold Out');
        this.atcBtn.dataset.variantId = v.id;
      }

      // Sync sticky bar
      this._syncStickyBar(v);

      // Sync sheet header + footer ATC
      if (this.sheetHdrPrice)   this.sheetHdrPrice.textContent  = v.pf;
      if (this.sheetHdrCompare) {
        if (v.cf) { this.sheetHdrCompare.textContent = v.cf; this.sheetHdrCompare.style.display = ''; }
        else { this.sheetHdrCompare.style.display = 'none'; }
      }
      if (this.sheetAtcBtn) {
        this.sheetAtcBtn.disabled    = !v.available;
        this.sheetAtcBtn.textContent = v.available ? (this.atcBtn && this.atcBtn.dataset.atc || 'Add to Cart') : (this.atcBtn && this.atcBtn.dataset.soldout || 'Sold Out');
      }

      // Sync swatch-mode price row (show_as_color_swatch = true)
      [this.root, this.sheetBody].filter(Boolean).forEach(container => {
        const swRow = container.querySelector('.bpd__swatch-price-row');
        if (!swRow) return;
        const pe = swRow.querySelector('.bpd__card-price');
        const ce = swRow.querySelector('.bpd__card-compare');
        const de = swRow.querySelector('.bpd__card-discount-badge');
        if (pe) pe.textContent = v.pf;
        if (ce) { ce.textContent = v.cf || ''; ce.style.display = v.cf ? '' : 'none'; }
        if (de) {
          if (v.cp && v.cp > 0 && v.p < v.cp) {
            de.textContent   = Math.round((1 - v.p / v.cp) * 100) + '% OFF';
            de.style.display = '';
          } else {
            de.style.display = 'none';
          }
        }
      });
    }

    // ── Sync sticky bar content with current variant ─────────────────
    _syncStickyBar(v) {
      if (!this.sticky) return;

      // Image: prefer swatch → variant img
      if (this.stickyImg && v) {
        const swKey  = this.currentOpt1.toLowerCase() + '|' + this.currentOpt2.toLowerCase();
        const swatch = this.swatchMap[swKey] || this.swatchMap['|' + this.currentOpt2.toLowerCase()];
        const imgSrc = swatch || v.swatch || v.img;
        if (imgSrc) this.stickyImg.src = imgSrc;
      }

      // Variant label: "Model · Color"
      if (this.stickyVariantLabel) {
        const parts = [];
        if (this.currentOpt1) parts.push(this.currentOpt1);
        if (this.currentOpt2) parts.push(this.currentOpt2);
        this.stickyVariantLabel.textContent = parts.join(' · ');
      }

      // Price
      if (v && this.stickyPrice) this.stickyPrice.textContent = v.pf;
      if (this.stickyCmp) {
        if (v && v.cf) { this.stickyCmp.textContent = v.cf; this.stickyCmp.style.display = ''; }
        else { this.stickyCmp.style.display = 'none'; }
      }

      // ATC state
      if (this.stickyAtcBtn && v) {
        this.stickyAtcBtn.disabled    = !v.available;
        this.stickyAtcBtn.textContent = v.available ? (this.atcBtn && this.atcBtn.dataset.atc || 'Add to Cart') : (this.atcBtn && this.atcBtn.dataset.soldout || 'Sold Out');
      }
    }

    // ── Update color swatch images for current opt1 ─────────────────
    // Priority: specific override (opt1+opt2) → global override (opt2 only) → variant img → first product img
    _updateColorImages() {
      [this.root, this.sheetBody].filter(Boolean).forEach(container => {
        container.querySelectorAll('[data-opt2]').forEach(btn => {
          const opt2lc  = btn.dataset.opt2.toLowerCase();
          const specific = this.swatchMap[this.currentOpt1.toLowerCase() + '|' + opt2lc];
          const global   = this.swatchMap['|' + opt2lc];
          const k        = this.currentOpt1.toLowerCase() + '|' + opt2lc;
          const v        = this.variantMap[k];
          const img      = btn.querySelector('img');
          if (!img) return;
          img.src = specific || global || (v && v.swatch) || (v && v.img) || img.src;
        });
      });
    }

    // ── Opt1 description / badge / audio ───────────────────────────
    _updateOpt1Content() {
      const _cur = (this.currentOpt1 || '').trim().toLowerCase();
      const block = this.blocks.find(b => (b.opt1 || '').trim().toLowerCase() === _cur);

      if (this.opt1Badge) {
        const text = block && block.badge ? block.badge : '';
        this.opt1Badge.textContent   = text;
        this.opt1Badge.style.display = text ? '' : 'none';
      }

      if (this.opt1Desc) {
        this.opt1Desc.textContent = block && block.description ? block.description : '';
      }

      if (this.audioEl && this.audioBtn) {
        const url   = block && block.audio_url ? block.audio_url : '';
        const title = block && block.card_title ? block.card_title : this.currentOpt1;
        if (url) {
          this.audioEl.src = url;
          // Update button label to show selected model name
          const labelEl = this.audioBtn.querySelector('.bpd__audio-label');
          if (labelEl) labelEl.textContent = 'Listen to ' + title;
          this.audioBtn.style.display = '';
        } else {
          if (!this.audioEl.paused) this.audioEl.pause();
          this.audioEl.src            = '';
          this.audioBtn.style.display = 'none';
          this.audioBtn.classList.remove('playing');
        }
      }
    }

    // ── Bind all events ─────────────────────────────────────────────
    _bindEvents() {
      // Opt1 selector
      this.root.querySelectorAll('[data-opt1]').forEach(btn => {
        btn.addEventListener('click', () => {
          const k   = btn.dataset.opt1.toLowerCase() + '|' + this.currentOpt2.toLowerCase();
          const opt2 = this.variantMap[k] ? this.currentOpt2 : (this.opt2Values[0] || this.currentOpt2);
          this.update(btn.dataset.opt1, opt2);
          this._scrollToGallery();
        });
      });

      // Opt2 selector
      this.root.querySelectorAll('[data-opt2]').forEach(btn => {
        btn.addEventListener('click', () => {
          this.update(this.currentOpt1, btn.dataset.opt2);
          this._scrollToGallery();
        });
      });

      // Gallery arrows
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this._goTo(this.currentIdx - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this._goTo(this.currentIdx + 1));

      // Touch swipe on main image
      const mainWrap = this.root.querySelector('.bpd__gal-main');
      if (mainWrap) {
        let tx = 0;
        mainWrap.addEventListener('touchstart', e => { tx = e.changedTouches[0].clientX; }, { passive: true });
        mainWrap.addEventListener('touchend', e => {
          const dx = e.changedTouches[0].clientX - tx;
          if (Math.abs(dx) > 40) this._goTo(dx < 0 ? this.currentIdx + 1 : this.currentIdx - 1);
        }, { passive: true });
      }

      // Audio play / pause
      if (this.audioBtn && this.audioEl) {
        this.audioBtn.addEventListener('click', () => {
          if (this.audioEl.paused) {
            this.audioEl.play();
            this.audioBtn.classList.add('playing');
          } else {
            this.audioEl.pause();
            this.audioBtn.classList.remove('playing');
          }
        });
        this.audioEl.addEventListener('ended', () => this.audioBtn.classList.remove('playing'));
      }

      // Quantity +/-
      const qtyInput = this.root.querySelector('.bpd__qty-input');
      const qtyDec   = this.root.querySelector('.bpd__qty-dec');
      const qtyInc   = this.root.querySelector('.bpd__qty-inc');
      if (qtyInput) {
        if (qtyDec) qtyDec.addEventListener('click', () => { qtyInput.value = Math.max(1, parseInt(qtyInput.value) - 1); });
        if (qtyInc) qtyInc.addEventListener('click', () => { qtyInput.value = parseInt(qtyInput.value) + 1; });
        qtyInput.addEventListener('change', () => {
          const n = parseInt(qtyInput.value);
          qtyInput.value = isNaN(n) || n < 1 ? 1 : n;
        });
      }

      // Add to cart
      if (this.atcBtn) this.atcBtn.addEventListener('click', () => this._addToCart());
    }

    // ── Add to cart ─────────────────────────────────────────────────
    // Mirrors Dawn's product-form.js:
    //  POST /cart/add.js with section IDs → response includes re-rendered HTML
    //  renderContents() → updates cart drawer, count badge, progress bar
    //  publish(PUB_SUB_EVENTS.cartUpdate) → notifies all subscribers
    _addToCart(triggerBtn, triggerQtyEl) {
      const variantId = this.bundleUpgradeId || this.currentVariantId;
      if (!variantId) return;

      const btn      = triggerBtn || this.atcBtn;
      const qtyInput = triggerQtyEl || this.root.querySelector('.bpd__qty-input');
      const qty      = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;
      const origText = btn ? btn.textContent : '';

      if (btn) { btn.disabled = true; btn.textContent = '...'; }

      // Collect section IDs using .section (Shopify section ID) — Dawn does the same
      const cartDrawer = document.querySelector('cart-drawer');
      let sectionIds = [];
      try {
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          sectionIds = cartDrawer.getSectionsToRender().map(s => s.section || s.id);
        }
      } catch (_) {}

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body:    JSON.stringify({
          id:           variantId,
          quantity:     qty,
          sections:     sectionIds,
          sections_url: window.location.pathname,
        }),
      })
        .then(r => r.json())
        .then(data => {
          if (data.status) throw new Error(data.description || 'Cart error');

          if (btn) btn.textContent = 'Added!';
          this._closeSheet();

          // Notify PubSub subscribers (progress bar, count badge)
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source:           'product-form',
              productVariantId: variantId,
              cartData:         data,
            });
          }

          // Update cart drawer DOM (drawer opens, count bubble, progress bar HTML)
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(data);
          }

          setTimeout(() => {
            if (btn) btn.disabled = false;
            this._updatePrice();
          }, 1600);
        })
        .catch(() => {
          if (btn) { btn.disabled = false; btn.textContent = origText; }
        });
    }

    // ── Build bottom sheet ───────────────────────────────────────────
    _buildSheet() {
      this.sheetEl = this.root.querySelector('.bpd-sheet');
      if (!this.sheetEl) return;

      this.sheetBody       = this.sheetEl.querySelector('.bpd-sheet__body');
      this.sheetAtcBtn     = this.sheetEl.querySelector('.bpd-sheet__atc');
      this.sheetHdrImg     = this.sheetEl.querySelector('.bpd-sheet__hdr-img');
      this.sheetGalImg     = this.sheetEl.querySelector('.bpd-sheet__gal-img');
      this.sheetHdrPrice   = this.sheetEl.querySelector('.bpd-sheet__hdr-price');
      this.sheetHdrCompare = this.sheetEl.querySelector('.bpd-sheet__hdr-compare');

      // Clone entire .bpd__variant-selector (preserves mobile-stack + class hierarchy)
      if (this.sheetBody) {
        const variantSelector = this.root.querySelector('.bpd__variant-selector');
        if (variantSelector) {
          this.sheetBody.appendChild(variantSelector.cloneNode(true));
        }

        // Bind opt1 clicks in sheet
        this.sheetBody.querySelectorAll('[data-opt1]').forEach(btn => {
          btn.addEventListener('click', () => {
            const k   = btn.dataset.opt1.toLowerCase() + '|' + this.currentOpt2.toLowerCase();
            const opt2 = this.variantMap[k] ? this.currentOpt2 : (this.opt2Values[0] || this.currentOpt2);
            this.update(btn.dataset.opt1, opt2);
          });
        });

        // Bind opt2 clicks in sheet
        this.sheetBody.querySelectorAll('[data-opt2]').forEach(btn => {
          btn.addEventListener('click', () => this.update(this.currentOpt1, btn.dataset.opt2));
        });
      }

      // Sheet qty buttons
      const sheetQtyInput = this.sheetEl.querySelector('.bpd-sheet__qty-input');
      const sheetQtyDec   = this.sheetEl.querySelector('.bpd-sheet__qty-dec');
      const sheetQtyInc   = this.sheetEl.querySelector('.bpd-sheet__qty-inc');
      if (sheetQtyInput) {
        if (sheetQtyDec) sheetQtyDec.addEventListener('click', () => { sheetQtyInput.value = Math.max(1, parseInt(sheetQtyInput.value) - 1); });
        if (sheetQtyInc) sheetQtyInc.addEventListener('click', () => { sheetQtyInput.value = parseInt(sheetQtyInput.value) + 1; });
        sheetQtyInput.addEventListener('change', () => {
          const n = parseInt(sheetQtyInput.value);
          sheetQtyInput.value = isNaN(n) || n < 1 ? 1 : n;
        });
      }

      // Sheet ATC
      if (this.sheetAtcBtn) {
        this.sheetAtcBtn.addEventListener('click', () => this._addToCart(this.sheetAtcBtn, sheetQtyInput));
      }

      // Close button + overlay
      const closeBtn = this.sheetEl.querySelector('.bpd-sheet__close');
      if (closeBtn) closeBtn.addEventListener('click', () => this._closeSheet());
      const overlay = this.sheetEl.querySelector('.bpd-sheet__overlay');
      if (overlay) overlay.addEventListener('click', () => this._closeSheet());

      // Escape key
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && this.sheetEl && this.sheetEl.classList.contains('bpd-sheet--open')) {
          this._closeSheet();
        }
      });
    }

    // ── Open / close bottom sheet ────────────────────────────────────
    _openSheet() {
      if (!this.sheetEl) return;
      this.sheetEl.setAttribute('aria-hidden', 'false');
      this.sheetEl.classList.add('bpd-sheet--open');
      document.body.style.overflow = 'hidden';
    }

    _closeSheet() {
      if (!this.sheetEl || !this.sheetEl.classList.contains('bpd-sheet--open')) return;
      this.sheetEl.classList.remove('bpd-sheet--open');
      this.sheetEl.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // ── Scroll to gallery on mobile when variant changes ────────────
    _scrollToGallery() {
      if (window.innerWidth > 768) return;
      const gallery = this.root.querySelector('.bpd__gallery');
      if (!gallery) return;
      const top = gallery.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
      const headerH = document.querySelector('.balmy-header')?.offsetHeight || 0;
      window.scrollTo({ top: top - headerH - 8, behavior: 'smooth' });
    }

    // ── Set up sticky bar ────────────────────────────────────────────
    _setupSticky() {
      this.sticky = this.root.querySelector('.bpd-sticky');
      if (!this.sticky) return;

      this.stickyImg          = this.sticky.querySelector('.bpd-sticky__img');
      this.stickyVariantLabel = this.sticky.querySelector('.bpd-sticky__variant-label');
      this.stickyPrice        = this.sticky.querySelector('.bpd-sticky__price');
      this.stickyCmp          = this.sticky.querySelector('.bpd-sticky__compare');
      this.stickyAtcBtn       = this.sticky.querySelector('.bpd-sticky__atc');

      // Show bar when the entire section has scrolled past the top
      const obs = new IntersectionObserver(entries => {
        entries.forEach(e => {
          const show = !e.isIntersecting;
          this.sticky.classList.toggle('bpd-sticky--visible', show);
          this.sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0 });
      obs.observe(this.root);

      // Sticky body → open sheet
      const stickyBody = this.sticky.querySelector('.bpd-sticky__body');
      if (stickyBody) stickyBody.addEventListener('click', () => this._openSheet());

      // Sticky ATC → add to cart directly
      if (this.stickyAtcBtn) {
        this.stickyAtcBtn.addEventListener('click', () => this._addToCart(this.stickyAtcBtn, null));
      }
    }
  }

  // ── Init ──────────────────────────────────────────────────────────
  function init() {
    document.querySelectorAll('.bpd-root').forEach(root => {
      if (root._bpd) return;
      root._bpd = new BalmyProductDrum(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
